import React,{Component} from 'react';
import "./header/Header.css" 
import "../scss/general.css"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Moment from "moment";
import 'react-month-picker-dropdown/dist/index.css';
import ReactToPdf from "react-to-pdf";
import logo from "./images/loading.gif";
import '../scss/green-theme.css';
import Cookies from "universal-cookie";
import ModalLogin from './ModalLogin';
//import Mymodal from './modal';
import logonorecord from "./images/recordnotfound.png";


//import bg from "./images/KNS30.gif";

//import config from '../config';
//const monthsname=["January","February","March","April","May","June","July","August","September","October","November","December"];
const axios = require("axios");
const ref = React.createRef();
const cookies = new Cookies();
export default class Repair extends Component{
  constructor(props)
  {
    super(props);
    this.state=
    { input:{},
      myitems:[],
      isLoaded: false,
      isData: false,
      Searchstring: "",
      fromDate: new Date(),
      toDate: new Date(),
      ErrMsg:"",
      divonoff:"none",
      fdate: Moment(new Date()).format("DD/MM/YYYY"),
      tdate: Moment(new Date()).format("DD/MM/YYYY")
    };
    this.handlechangefrom = this.handlechangefrom.bind(this);
    this.handlechangeto = this.handlechangeto.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeS = this.handleChangeS.bind(this);
  }
  cur(num) 
  {
    let cnum=parseInt(num,0);
    if(cnum > 0)
        return cnum.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    else
        return "-"
 }
 componentDidMount()
 {
    let input = this.state.input;
    if(cookies.get("LoginID"))
    { input["ID"]=cookies.get("LoginID");
      this.setState({input,ErrMsg:"",divonoff:"none",myitems:[]});
    }
    else
    { this.setState({ErrMsg:<ModalLogin/>});}
 }

 handleChangeS(e)
 {
    this.setState({Searchstring: e.target.value});
 }
  handlechangefrom(date)
  {
    this.setState({fdate:Moment(date).format("DD/MM/YYYY")});
    this.setState({fromDate: date});
  }
  handlechangeto(date)
  {
    this.setState({tdate:Moment(date).format("DD/MM/YYYY")});
    this.setState({toDate:date});
  }

  handleSubmit()
  {
      document.body.style.cursor="wait";
      this.setState({ErrMsg:<img src={logo}  alt=""/>,myitems:[],divonoff:"none"});
      let input=this.state.input;
      input["DateFrom"]=this.state.fdate;
      input["DateTo"]=this.state.tdate;
      input["Search"]=this.state.Searchstring;
      this.setState({input});
      this.setState({isLoaded: false});
      axios({
          method: 'post',
          url: cookies.get("phpclass")+'/index.php/userv/repair/',
          data: this.state.input,
          headers: {'Content-Type': 'multipart/form-data'}
      })
      .then((response)=> {
          document.body.style.cursor="default";
          if(response.data==0)
          this.setState({ErrMsg:<img style={{paddingTop:50}} src={logonorecord} alt=""/>,divonoff:"none"});
          else
            this.setState({
              isLoaded: true,
              ErrMsg:"",
              divonoff:"block",
              myitems: response.data
          });
      })
      .catch((response)=> {
        document.body.style.cursor="default";
        this.setState({ErrMsg:<img style={{paddingTop:50}} src={logonorecord} alt=""/>,divonoff:"none"});

//        this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
      });      

    }
    render()
    {
//      let isLoaded = this.state.isLoaded;
      let items = this.state.myitems;
      let fileName=cookies.get("LoginID")+"-repair.pdf";
      return(
        <div className="container1">
        <div width="100%"  >

          <div className='inner-profile'>
            <span className="box-title">Repair and Maintenance</span>
            <div className="inner-profile2">

              <label style={{paddingLeft:2,width:"85px"}}>From: </label>
                <DatePicker
                  selected={this.state.fromDate }
                  value = {this.state.fromDate}
                  onChange={this.handlechangefrom}
                  name="fromDate"
                  dateFormat="dd/MM/yyyy" className="form_control"/>
                  <br></br>
              <label style={{paddingLeft:2,width:"85px"}}>To: </label>

              <DatePicker
                selected={ this.state.toDate }
                value = {this.state.toDate}
                onChange={this.handlechangeto}
                name="toDate"
                dateFormat="dd/MM/yyyy" className="form_control"/>
                
              <br></br>
              <label style={{paddingLeft:2,width:"85px"}}>Search for: </label>
              <input className="form-control"  onBlur={this.handleChangeS}/>
              <button onClick={this.handleSubmit} style={{float:"right"}}>Submit</button>
            <br></br>       
            </div>

            <div style={{width:"100%",textAlign:"center",display:this.state.divonoff}} >

            <table style={{width:"100%"}} ref={ref}>

                <thead>
                  <tr >
                    <th className="thm" scope="col">Date (dd/mm/yyyy)</th>
                    <th className="thm" scope="col">Vehicle#</th>
                    <th className="thm" scope="col">Meter Reading (KM)</th>
                    <th className="thm" scope="col">Description/Detail</th>
                    <th className="thm" scope="col">Service Point/Vendor</th>
                    <th className="thm" scope="col">Expense amount</th>
                  </tr>
                </thead>
                <tbody >
                  {items.map((result ,i) => {
                  return (
                    <tr className="trc" key={i}>
                      <td className="tdamcenter" >{Moment(result.job_order_date).format("DD/MM/YYYY")}</td>
                      <td className="tdamcenter" >{result.Veh_Reg_Num}</td>
                      <td className="tdamcenter" >{result.Curr_Mtr_Reading}</td>
                      <td className="tddesc" >{result.Item}</td>
                      <td className="tddesc" >{result.supplier}</td>
                      <td className="tdamb" >{this.cur(result.Amount)}</td>
                    </tr>
                  )})}
                  </tbody>
                </table>
                <ReactToPdf targetRef={ref} filename={fileName} x={15} y={10}>
                    {({toPdf}) => (
                    <button onClick={toPdf} style={{background: "linear-gradient(to bottom , #ffffff 0%, black 100%)"}}>Download pdf</button>
                    )}
                    </ReactToPdf>
                    </div>
              <br></br>
              </div>

          </div>
          <p style={{textAlign:"center"}}>{this.state.ErrMsg}</p>
        </div>
        );
      }    
    }
